/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_booking_messages = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		TinyMCE: Init
		*/
		form_htmleditors.initHTMLEditor(0);

		/*
		Message: Submit
		*/
		$(document).on('click', '.js-message-submit', function() {
			specific_booking_messages.submit();
		});

		/*
		Notice: New fade out
		*/
		$('.js-messages-new').fadeOut(300);

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.submit = function() {

		/*
		Get: Text
		*/
		var _message_text = tinymce.get('js-message-text').getContent();

		/*
		XHR
		*/
		$.ajax({
			url: globalUrl + '/a/a/message-submit',
			type: "POST",
			data: {
				message_text: _message_text
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Good to go
			*/
			if(data == 1) {

				/*
				Reload
				*/
				$('.js-nav').find('.active').trigger('click');

				/*
				Notifier
				*/
				specific_loader.notifier(
					1,
					0,
					'Uw bericht is succesvol verzonden.'
				);

			} else {

				specific_interactions_formhandling.formHandling(0,0,data);

			}

		})
		.always(function() {
		});

	};
			
}).apply(specific_booking_messages); 